export class WaybillOverviewLoad {
  public static readonly type = '[WaybillOverview] Load Overview';
  constructor(public payload: string) {}
}

export class WaybillOverviewSetInitialState {
  public static readonly type = '[WaybillOverview] Set Initial State';
}
